<template>
  <div class='radio-button-select'>
    <b-field>
        <template v-if='label' #label>
          <label class='label'>{{ label }}</label>
        </template>

        <b-radio-button
          v-for='option in options'
          v-model='selection'
          :native-value='option.value'
          @input="$emit('input', selection)">

          {{ option.label ? option.label : option.value }}
        </b-radio-button>
    </b-field>
  </div>
</template>



<script>
  //import SubComponent from '../components/SubComponent'

  export default {
      name: 'component-name',
      components: { /* Subcomponents */ },
      props: ['options', 'default', 'label'],
      data() { return {
        selection: null
      }},
      beforeCreate() {},
      created() {},
      mounted() {
        if(this.default !== undefined) this.selection = this.default
      },
      updated() {},
      computed: { /*
          Creates a new property
          Updates when any dependant property changes */
      },
      watch: { /*
          Watches an existing property
          Only runs when the watched property changes */
      },
      methods: {}
  }
</script>



<style scoped>

</style>